import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cr_cart")) || []; }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("cr_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, size = null, quantity = 1) => {
    setItems((prev) => {
      const key = `${product.id}-${size || ""}`;
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) => i.key === key ? { ...i, quantity: i.quantity + quantity } : i);
      }
      return [...prev, {
        key, product_id: product.id, name: product.name, price: product.price,
        image: product.image, size, quantity,
      }];
    });
  };

  const updateQty = (key, quantity) => {
    if (quantity < 1) return removeItem(key);
    setItems((prev) => prev.map((i) => i.key === key ? { ...i, quantity } : i));
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, count, total }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
